<template>
  <v-navigation-drawer app v-model="drawer">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle class="d-flex justify-center">
          <img
            @click="handleClickLogo()"
            src="@/assets/logo-transparente.png"
            class="d-flex mb-4"
            id="logo-click"
            width="150"
          />
        </v-list-item-subtitle>
        <v-list-item-title class="mb-3"
          >{{ getTextByType(userData.type) }}
        </v-list-item-title>
        <v-list-item-subtitle>
          Usuário: {{ userData.name }}
        </v-list-item-subtitle>
        <v-list-item-subtitle class="mt-2">
          <v-btn
            color="blue darken-3"
            small
            class="white--text"
            v-if="
              userData.type !== 'photo' &&
              userData.type !== 'royalties' &&
              userData.type !== 'admin'
            "
            @click="handleClickSettings()"
          >
            <v-icon left color="white">mdi-cog</v-icon> Trocar Empresa
          </v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav v-if="userData.type === 'admin'">
      <v-list-item link to="/dashboard">
        <!-- <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon> -->

        <v-list-item-content>
          <v-list-item-title>DASHBOARD</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group :value="true">
        <template v-slot:activator>
          <v-list-item-title>CADASTRO</v-list-item-title>
        </template>
        <v-list-item link to="/empresa">
          <v-list-item-icon>
            <v-icon>mdi-domain</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/usuario">
          <v-list-item-icon>
            <v-icon color="">mdi-account-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/tipo-fornecedor">
          <v-list-item-icon>
            <v-icon>mdi-cube</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tipos de Fornecedor</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/categoria">
          <v-list-item-icon>
            <v-icon>mdi-archive</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Categorias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/subcategoria">
          <v-list-item-icon>
            <v-icon>mdi-archive-arrow-down-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Subcategoria</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/unidade-medida">
          <v-list-item-icon>
            <v-icon>mdi-pencil-ruler</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Unidades de Medida</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/material">
          <v-list-item-icon>
            <v-icon>mdi-palette-swatch</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Material</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/cor">
          <v-list-item-icon>
            <v-icon>mdi-palette</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tabela de Cores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/tecnologia">
          <v-list-item-icon>
            <v-icon>mdi-folder-star-multiple-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tecnologias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/grade-produto">
          <v-list-item-icon>
            <v-icon color="">mdi-grid</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Grade de Produtos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/colecao">
          <v-list-item-icon>
            <v-icon>mdi-weather-partly-cloudy</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Coleções</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/transportadora">
          <v-list-item-icon>
            <v-icon color="">mdi-truck-delivery</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Transportadoras</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/ncm">
          <v-list-item-icon>
            <v-icon>mdi-shopping-search</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>NCM</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/cest">
          <v-list-item-icon>
            <v-icon>mdi-database-search-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>CEST</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>PRODUTO</v-list-item-title>
        </template>
        <v-list-item link to="/produto">
          <v-list-item-icon>
            <v-icon color="">mdi-shoe-formal</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Cadastro/Consulta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/solado">
          <v-list-item-icon>
            <v-icon color="">mdi-shoe-formal</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Solados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/tipo-produto">
          <v-list-item-icon>
            <v-icon color="">mdi-text-box-multiple-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tipo de Produto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/atualizar-preco">
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Atualização de Preço</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/mudar-colecao">
          <v-list-item-icon>
            <v-icon>mdi-weather-cloudy-arrow-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Mudança de Coleção</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/bloquear-produto">
          <v-list-item-icon>
            <v-icon color="yellow">mdi-book-cancel-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Bloquear Produtos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/importar-produto">
          <v-list-item-icon>
            <v-icon color="">mdi-cloud-tags</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Importar Produtos (XML)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link to="/#">
          <v-list-item-icon>
            <v-icon color="red">mdi-cloud-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Exportar Tabela Preço</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-group>
      <!-- PEDIDOS -->
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>SISTEMA DE PEDIDOS</v-list-item-title>
        </template>
        <!-- AQUI RENDERIZA A LISTA DE ITENS DO PEDIDO -->
        <v-list-item
          link
          v-for="item in invoices.invoices"
          :key="item.id"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>PEDIDO EXPRESS</v-list-item-title>
        </template>
        <v-list-item
          link
          v-for="item in express.itens"
          :key="item.id"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>FORNECEDOR</v-list-item-title>
          </v-list-item-content>
        </template>
        <!-- AQUI RENDERIZA A LISTA DE ITENS DE CONFIGURAÇÕES -->
        <v-list-item
          link
          v-for="item in invoices.settings"
          :key="item.id"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- ROYALTIES -->
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>CONTROLE DE ROYALTIES</v-list-item-title>
        </template>
        <v-list-group :value="false" sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cadastro</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/CADASTRO -->
          <v-list-item
            link
            v-for="item in royalties.registers"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="false" sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Royalties</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/EMISSAO|CANCELAMENTO|REEMBOLSO|IMPRESSAO -->
          <v-list-item
            link
            v-for="item in royalties.royalties"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="false" sub-group v-if="false">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Publicação</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/PUBLICACAO -->
          <v-list-item
            link
            v-for="item in royalties.publishes"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="false" sub-group v-if="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Relatórios</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/PUBLICACAO -->
          <v-list-item
            link
            v-for="item in royalties.reports"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-group>
      <!-- RELATORIOS -->
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>RELATÓRIOS</v-list-item-title>
        </template>
        <v-list-item link to="/relatorio/empresas">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/royalties">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Royalties</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/produtos">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Produtos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/precos">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tabela de Preços</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/pedidos">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/cores">
          <v-list-item-icon>
            <v-icon>mdi-table-arrow-down</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Cores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/materiais">
          <v-list-item-icon>
            <v-icon>mdi-table-arrow-down</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Materiais</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/produtos-omie">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Produtos Sistema Omie</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>FOTOGRÁFO</v-list-item-title>
        </template>
        <v-list-item link to="/fotografo/upload">
          <v-list-item-icon>
            <v-icon color="">mdi-image-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Subir Imagens</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fotografo/historico">
          <v-list-item-icon>
            <v-icon color="">mdi-image-album</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Histórico de Upload</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="false">
        <template v-slot:activator>
          <v-list-item-title>FORNECEDOR</v-list-item-title>
        </template>
        <v-list-item link to="/fornecedor/pedidos">
          <v-list-item-icon>
            <v-icon color="">mdi-file-document-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/importar-produto">
          <v-list-item-icon>
            <v-icon color="">mdi-cloud-tags</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Importar Produtos (XML)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/lista-importar">
          <v-list-item-icon>
            <v-icon color="yellow">mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Lista Produtos Importados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/importar-preco">
          <v-list-item-icon>
            <v-icon color="red">mdi-table-arrow-left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Importar Tabela <br />de Preços (CSV)</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/historico-importar">
          <v-list-item-icon>
            <v-icon color="red">mdi-calendar-import</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Histórico <br />Importar Produtos</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/historico-transferencia">
          <v-list-item-icon>
            <v-icon color="">mdi-history</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Histórico <br />
              Transferência Pedidos</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-list dense nav v-if="companySelected.type === 'for'">
      <v-list-item link to="/dashboard">
        <!-- <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon> -->

        <v-list-item-content>
          <v-list-item-title>DASHBOARD</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group :value="true" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>FORNECEDOR</v-list-item-title>
        </template>
        <v-list-item link to="/fornecedor/pedidos">
          <v-list-item-icon>
            <v-icon color="">mdi-file-document-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="false" link to="/fornecedor/importar-produto">
          <v-list-item-icon>
            <v-icon color="">mdi-cloud-tags</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Importar Produtos (XML)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="false" link to="/fornecedor/lista-importar">
          <v-list-item-icon>
            <v-icon color="yellow">mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Lista Produtos Importados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="false" link to="/fornecedor/importar-preco">
          <v-list-item-icon>
            <v-icon color="red">mdi-table-arrow-left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Importar Tabela <br />de Preços (CSV)</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="false" link to="/fornecedor/historico-importar">
          <v-list-item-icon>
            <v-icon color="red">mdi-calendar-import</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Histórico <br />Importar Produtos</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fornecedor/historico-transferencia">
          <v-list-item-icon>
            <v-icon color="">mdi-history</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              >Histórico <br />
              Transferência Pedidos</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/express/lancamento-estoque">
          <v-list-item-icon>
            <v-icon color="yellow">mdi-file</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ajuste no Estoque</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>RELATÓRIOS</v-list-item-title>
        </template>
        <v-list-item link to="/relatorio/pedidos">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/cores">
          <v-list-item-icon>
            <v-icon>mdi-table-arrow-down</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Cores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/materiais">
          <v-list-item-icon>
            <v-icon>mdi-table-arrow-down</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Materiais</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-list
      dense
      nav
      v-if="companySelected.type === 'fra' || companySelected.type === 'mul'"
    >
      <v-list-item link to="/dashboard">
        <!-- <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon> -->

        <v-list-item-content>
          <v-list-item-title>DASHBOARD</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- PEDIDOS -->
      <v-list-group :value="true" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>SISTEMA DE PEDIDOS</v-list-item-title>
        </template>
        <!-- AQUI RENDERIZA A LISTA DE ITENS DO PEDIDO -->
        <v-list-item
          link
          v-for="item in filterInvoices(invoices.invoices)"
          :key="item.id"
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>PEDIDO EXPRESS</v-list-item-title>
        </template>
        <v-list-item link to="/express/pedido">
          <v-list-item-icon>
            <v-icon>mdi-cart-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Emissão de Pedido Express</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group> -->
      <v-list-group :value="false" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>RELATÓRIOS</v-list-item-title>
        </template>
        <v-list-item link to="/relatorio/pedidos">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatório de Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorio/publicacoes">
          <v-list-item-icon>
            <v-icon>mdi-file</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Relatórios Publicados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-list dense nav v-if="userData.type === 'photo'">
      <v-list-group :value="true" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>FOTOGRÁFO</v-list-item-title>
        </template>
        <v-list-item link to="/fotografo/upload">
          <v-list-item-icon>
            <v-icon color="">mdi-image-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Subir Imagens</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/fotografo/historico">
          <v-list-item-icon>
            <v-icon color="">mdi-image-album</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Histórico de Upload</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-list dense nav v-if="userData.type === 'royalties'">
      <v-list-item link to="/dashboard">
        <!-- <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon> -->

        <v-list-item-content>
          <v-list-item-title>DASHBOARD</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group :value="true" v-if="true">
        <template v-slot:activator>
          <v-list-item-title>CONTROLE DE ROYALTIES</v-list-item-title>
        </template>
        <v-list-group :value="false" sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cadastro</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/CADASTRO -->
          <v-list-item
            link
            v-for="item in royalties.registers"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="true" sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Royalties</v-list-item-title>
            </v-list-item-content>
          </template>
          <!-- AQUI RENDERIZA A LISTA DE ITENS DO ROYALTIES/EMISSAO|CANCELAMENTO|REEMBOLSO|IMPRESSAO -->
          <v-list-item
            link
            v-for="item in royalties.royalties"
            :key="item.id"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="false" v-if="true" sub-group>
          <template v-slot:activator>
            <v-list-item-title>Relatórios</v-list-item-title>
          </template>
          <v-list-item link to="/relatorio/empresas">
            <v-list-item-icon>
              <v-icon>mdi-file</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Relatório de Empresas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/relatorio/royalties">
            <v-list-item-icon>
              <v-icon>mdi-file</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Relatório de Royalties</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-group>
    </v-list>
    <!-- -->
    <!-- <router-link to="/">Home</router-link> | -->
    <!-- <router-link to="/about">About</router-link> -->
    <template v-slot:append>
      <div class="pa-2 d-flex justify-center black">
        <img
          src="@/assets/logo-sergios.png"
          class="d-flex mb-1"
          id="logo-click"
          width="90"
        />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { invoices, royalties, express } from "@/helpers/routes_menu";
export default {
  props: {
    drawer: Boolean,
    userData: Object,
    companySelected: {
      type: Object,
      default: () => ({}),
    },
    handleClickSettings: Function,
  },
  data: () => ({
    invoices: {},
    royalties: {},
    express: {},
  }),
  created() {
    this.invoices = invoices;
    this.royalties = royalties;
    this.express = express;
    if (typeof this.companySelected === "undefined") {
      this.companySelected.type = "";
    }
  },
  methods: {
    handleClickLogo() {
      if (this.$route.name !== "Home") {
        this.$router.push({ name: "Home" });
      }
    },
    getTextByType(type) {
      if (type === "provider" || type === "franchise") {
        if (Object.keys(this.companySelected).length > 0) {
          if (type === "provider") {
            return `${this.companySelected.code} - ${this.companySelected.description}`;
          } else {
            return `${this.companySelected.code} - ${this.companySelected.name}`;
          }
        } else if (type === "provider") {
          return "Fornecedor";
        } else {
          return "Franqueado";
        }
      } else {
        return "Franqueadora";
      }
    },
    filterRoyaltiesRegisters(routes) {
      return routes.filter(
        (item) =>
          item.link === "/royalties/cadastro/tipos-lancamento" ||
          item.link === "/royalties/cadastro/motivo-cancelamento-reembolso" ||
          item.link === "/royalties/cadastro/motivo-cancelamento-royalties"
      );
    },
    filterInvoices(routes) {
      console.log(routes);
      return routes.filter(
        (item) => item.link !== "/pedidos/franqueadora/listar"
      );
    },
  },
};
</script>

<style scoped>
#logo-click {
  cursor: pointer;
}
</style>
<style>
.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 0.9rem;
}
.v-application--is-ltr
  .v-list--dense
  .v-list-group--sub-group
  .v-list-group__header {
  padding-left: 12px;
}
.v-application--is-ltr
  .v-list-group--sub-group
  .v-list-group__items
  .v-list-item {
  padding-left: 25px;
}
</style>
